import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const postToken = async (user, pass) => {
    try {
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'text/plain'
            },
            body: `grant_type=password&username=${user}&password=${pass}&client_id=Unisync&captchaToken=&origin=home`,
        };

        const url = `${apiUrl}token`;

        const response = await fetch(url, options);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ha ocurrido un error:', error);
        throw error;
    }
};

const refreshAccessToken = (refreshToken) => {

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'text/plain'
        },
        body: `grant_type=refresh_token&refresh_token=${refreshToken}&client_id=Unisync`,
    }

    const url = `${apiUrl}token`

    return fetch(url, options)
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch(error => console.log('Ha ocurrido un error:', error))
}

const checkTokenExpired = (accessToken) => {

    const url = `${apiUrl}AuthorizedPing`

    return fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}


export { postToken, refreshAccessToken, checkTokenExpired }